import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useToastNotificationStore } from "../store/toast-notifications";
// Components
import ToastContainer from "./containers/ToastContainer.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    ...{ name: "ToastNotificationsView" },
    __name: 'ToastNotificationsView',
    setup(__props) {
        const $notificationsStore = useToastNotificationStore();
        return (_ctx, _cache) => {
            return (_unref($notificationsStore).state.toastList?.length)
                ? (_openBlock(), _createBlock(ToastContainer, {
                    key: 0,
                    "toast-list": _unref($notificationsStore).state.toastList,
                    onToastHover: _unref($notificationsStore).toastHover,
                    onToastClick: _unref($notificationsStore).toastClick,
                    onPrimaryAction: _unref($notificationsStore).primaryAction,
                    onSecondaryAction: _unref($notificationsStore).secondaryAction,
                    onCloseAll: _unref($notificationsStore).closeAllToasts,
                    onCloseToast: _unref($notificationsStore).closeToast
                }, null, 8, ["toast-list", "onToastHover", "onToastClick", "onPrimaryAction", "onSecondaryAction", "onCloseAll", "onCloseToast"]))
                : _createCommentVNode("", true);
        };
    }
});
